// TODO: roles should be gotten from API
export const PIONEER_ORGANIZATION_ID = 1;

export const canOrganizationCreateBuildings = (organizationId?: number | null) =>
  typeof organizationId === 'number' && organizationId !== PIONEER_ORGANIZATION_ID;

export const roles = [
  {
    value: 'basic',
    label: 'Basic',
  },
  {
    value: 'admin',
    label: 'Admin',
  },
  {
    value: 'no-access',
    label: 'No Access',
  },
];
